
import { Component, Vue } from 'vue-property-decorator'
import GoodsSwipe from "@/components/GoodsSwipe/index.vue";
import {
  addFavoriteGoods,
  deleteFavoriteGoods,
  getShopGoodsInfo,
  isFavoriteGoods, isOptionalGoods,
  ShopGoodsInfoDto
} from "@/api/shoppingMall";
import { getGoodsSpecificationList, PackageListDto, getShoppingCart } from "@/api/buyCar";
import PackageSelector from "@/components/PackageSelector/index.vue";
import { Getter } from "vuex-class";
import { shareToWeiXin } from "@/utils/h5ToApp";
import { refreshPage } from '@/utils/appToH5';
import { handleFill,imagePreview } from '@/utils/util'
@Component({
  name: 'GoodsDetail',
  components: { GoodsSwipe, PackageSelector }
})
export default class GoodsDetail extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  handleFill = handleFill
  imagePreview = imagePreview

  isFavorite = false
  params = {
    companyId: "",
    customerId: "",
    goodsId: "",
    shopId: ""
  }
  detailInfo: ShopGoodsInfoDto = {}
  defaultDetailInfo: ShopGoodsInfoDto = {} // 默认的后端接口返回的数据，用于取消掉规格之后的数据重置
  packageList: PackageListDto[] = []
  onlyOnePackage = false // 判断是否只有一个套餐
  packageName = '' // 套餐名称
  packageWeight = '' // 套餐重量
  selectValueList: string[] = [] // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格
  buycarLength = 0

  created () {
    this.params.companyId = this.companyId
    this.params.customerId = this.companyId
    this.params.shopId = this.providerId
    this.params.goodsId = this.$route.query.goodsId as string
    this.$eventBus.$on('refreshCar',()=>{
      this.getShoppingCart()
    })
    this.getInfo()
    this.isFavoriteFunc()
    this.getPackageList()
  }

  getShoppingCart() {
    getShoppingCart({ companyId: this.companyId }).then(res => {
      this.buycarLength = res.data.length
      console.log(res.data)
    })
  }

  /* 获取商品详细信息 */
  getInfo () {
    getShopGoodsInfo(this.params).then((res) => {
      this.detailInfo = res.data || {}
      this.defaultDetailInfo = JSON.parse(JSON.stringify(this.detailInfo))
    })
  }

  /* 判断是否已收藏 */
  isFavoriteFunc () {
    isFavoriteGoods(this.params).then((res) => {
      this.isFavorite = res.data.isFavorite
    })
  }

  getSelectPackageInfo (info: PackageListDto, selectValueList: string[]) {
    if (selectValueList && selectValueList.length > 0) {
      this.onlyOnePackage = true
      this.packageName = info.packageNameDesc
      this.packageWeight = info.weight
      this.detailInfo.goodsPrice = info.orderPrice
    } else {
      this.detailInfo.goodsPrice = this.defaultDetailInfo.goodsPrice
      if (this.defaultDetailInfo.isMultiSpec) {
        this.onlyOnePackage = false
        this.packageName = ''
        this.packageWeight = ''
      } else {
        this.onlyOnePackage = true
        this.packageWeight = this.packageList[0] && this.packageList[0].weight
        this.packageName = this.packageList[0] && this.packageList[0].packageNameDesc
      }
    }
    this.selectValueList = selectValueList
  }

  /**
   * 获取套餐列表
   * */
  getPackageList () {
    getGoodsSpecificationList(this.params).then((res) => {
      this.packageList = res.data.packageList || []
      if (this.packageList) {
        this.onlyOnePackage = this.packageList.length <= 1
        if (this.onlyOnePackage) {
          this.packageWeight = this.packageList[0] && this.packageList[0].weight
          this.packageName = this.packageList[0] && this.packageList[0].packageNameDesc
        }
      }
    })
  }

  /**
   * 打开选择规格弹窗
   * @param type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单
   */
  showRules (type = '3') {
    isOptionalGoods(this.params).then((res) => {
      if (res.data.isOptional) {
        (this.$refs.packageSelector as any).show({
          ruleType: type,
          detailInfo: this.detailInfo,
          selectList: this.selectValueList,
          defaultInfo: this.defaultDetailInfo,
        })
      } else {
        this.$dialog.alert({
          message: '商品过期不存在'
        }).then(() => {
          this.$router.back()
          window.sessionStorage.setItem('refresh', '1')
        })

      }
    }).catch(() => {
    }).finally(() => {

    })
  }

  favoritesFunc () {
    if (this.isFavorite) {
      deleteFavoriteGoods(this.params).then(() => {
        this.$toast.success('已取消收藏')
        this.isFavoriteFunc()
      }).catch(() => { })
    } else {
      addFavoriteGoods(this.params).then(() => {
        this.$toast.success('已收藏')
        this.isFavoriteFunc()
      }).catch(() => { })
    }

  }

  toBuyCar () {
    this.$router.push({
      path: '/buyCar'
    })
  }

  reloadInfo () {
    this.getInfo()
    this.isFavoriteFunc()
    this.getPackageList()
    this.selectValueList = []
  }

  /**
   * 调用原生方法分享
   */
  toShare () {
    const data = {
      title: this.detailInfo.goodsName || '商品详情',
      description: '',
      url: `${window.location.origin}/shareGoodsDetail?goodsId=${this.params.goodsId}&shopId=${this.params.shopId}`
    }
    console.log(this.detailInfo.goodsName || '商品详情')
    console.log(`${window.location.origin}/shareGoodsDetail?goodsId=${this.params.goodsId}&shopId=${this.params.shopId}`)
    shareToWeiXin(data)
    // this.$router.push({
    //     path: '/shareGoodsDetail',
    //     query: {
    //         goodsId: this.params.goodsId,
    //         shopId: this.params.shopId
    //     }
    // })
  }
}
